<div class="flex flex-col items-center gap-6 p-6 bg-white rounded-2xl" id="qrContainer">
  <div class="flex items-center gap-3">
    <img src="https://storage.googleapis.com/komerce/assets/svg/Qris-logo.svg" alt="QRIS Logo" class="w-24" />
    <span class="text-[20px] font-semibold text-[#667085]">QRIS Code</span>
  </div>

  <div class="flex flex-col gap-4 p-4 border border-gray-500 rounded-xl w-[300px]">
    <div class="p-8 border border-[#EAECF0] rounded-xl bg-white shadow-sm flex items-center justify-center">
      <div id="qrCodeDownload">
          <qrcode
            [qrdata]="data?.qris_string || data?.qris_content || ''"
            [imageSrc]="qrLogoBase64"
            [imageHeight]="40"
            [imageWidth]="40"
            [errorCorrectionLevel]="'M'"
            [margin]="1"
            [scale]="1"
            [width]="200"
          ></qrcode>
      </div>
    </div>

    <div class="w-full flex flex-col items-center justify-center py-4 px-6 border border-primary rounded-xl bg-[#FFF6F4] gap-1">
      <span class="text-[14px] text-[#A6ADB4]">Payment Amount</span>
      <span class="text-[20px] font-bold text-primary">Rp {{ (data?.final_amount | number : "1.0-2") || 0 }}</span>
    </div>
  </div>

  <button
    (click)="downloadQrCode()"
    nz-button
    nzType="primary"
    class="w-[300px] h-10"
  >
    Download QR Code
  </button>
</div>
